import { useCallback, useState } from 'react';

export default function useDisclosure(defaultIsOpen: boolean = false) {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const toggleIsOpen = useCallback(() => {
    setIsOpen((current) => !current);
  }, [setIsOpen]);

  return [isOpen, toggleIsOpen] as const;
}
